import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQiComponent } from './simple-icons-qi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQiComponent ],
    exports:      [ SimpleIconsQiComponent ],
    bootstrap:    []
})
export class SimpleIconsQiModule {}
